import { invariant } from '@/shared/utils/typeAssertions'
import { useLimitedAction } from '../Billing/useLimitedAction'
import { useWorkspaces } from '../Workspaces/useWorkspaces'
import type { Field } from './Fields/types'
import { useEntity } from './useEntity'
import { useProject } from './useProject'

export const useFieldRecompute = () => {
  const workspacesStore = useWorkspaces()
  const projectStore = useProject()
  const entityStore = useEntity()
  const { recalculateEntity } = useLimitedAction()
  const recomputeField = async (field: Field) => {
    if (field.status === 'computing') return
    invariant(workspacesStore.currentWorkspace, 'No current workspace')
    invariant(projectStore.projectId, 'No current project')

    const originalStatus = field.status
    const optimisticField = { ...field, status: 'computing' as const }

    entityStore.updateField(optimisticField)
    projectStore.updateField(optimisticField)

    const res = await recalculateEntity({
      workspaceId: workspacesStore.currentWorkspace.id,
      projectId: projectStore.projectId,
      entityId: field.entityId,
      propertyIds: [field.propertyId],
      force: true,
    })

    if (!res.ok) {
      const revertField = { ...field, status: originalStatus }
      entityStore.updateField(revertField)
      projectStore.updateField(revertField)
    }
  }

  return { recomputeField }
}
